<template>
  <el-dialog :title="form.id?'编辑内部员工':'添加内部员工'" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px">
    <el-form ref="dataForm" label-position="right"  :rules="formRules" :model="form" size="small" label-width="130px">
      <el-form-item label="当前部门：" prop="deptName" v-if="popType==2" class="width100">
        <el-input v-model="form.deptName" disabled />
      </el-form-item>
      <el-form-item :label="popType==2?'修改部门：':'部门：'" prop="deptId" class="width100" >
        <el-select v-model="form.deptId" placeholder="请选择">
          <el-option :label="item.value" :value="item.key" v-for="item in sectionList" :key="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="姓名：" prop="realName" class="width100" v-if="popType!=2" :rules="[{required: true,message: '请输入内部员工的姓名',trigger: 'blur'}]">
          <el-input v-model="form.realName" placeholder="请输入内部员工的姓名" />
      </el-form-item>
      <el-form-item label="手机号：" prop="userPho" class="width100" v-if="popType!=2" :rules="[{required: true,message: '请输入手机号',trigger: 'blur'}]">
          <el-input v-model="form.userPho" placeholder="请输入手机号" maxlength="11"/>
      </el-form-item>
      <el-form-item label="性别" prop="sex" v-if="popType!=2">
          <el-radio-group v-model="form.sex">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import userApi from '@/api/sys/user'
  function initFormBean() {
    const formBean = {
      realName:null,
      userPho:null,
      deptId:null,
      sex:1,
      isInternal:1,
      jobStatus:1,
      entryInhibited:0,
      userType:2
    }
    return formBean
  }

  export default {
    //popType 0:新增 1:编辑 2:修改身份
    props:{
      sectionList:Array,
      popType:Number
    },
    data() {
      return {
        form: initFormBean(),
        isLoading:false,
        formVisible: false,
        formRules: {
          deptId: [{
            required: true,
            message: '请选择部门',
            trigger: 'change'
          }],
          // realName: [{
          //   required: true,
          //   message: '请输入内部员工的姓名',
          //   trigger: 'blur'
          // }],
          // userPho: [{
          //   required: true,
          //   message: '请输入手机号',
          //   trigger: 'blur'
          // }],
        },
      }
    },
    created() {

    },
    methods: {
      resetForm() {
        this.form = initFormBean()
      },
      handleCreate() {
        this.resetForm()
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      handleUpdate(row) {
        // console.log('row: ',row);
        this.resetForm()
        this.form = {
          ...row
        }
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      doCreate() {
        this.$refs["dataForm"].validate((valid) => {
          if (valid) {
            // console.log('this.form: ',this.form);
            this.isLoading = true
            if(this.form.id){
              userApi.update(this.form).then((data) => {
                this.postCallback(data)
              }).catch(res=>{
                this.isLoading=false
              });
            }else{
              userApi.create(this.form).then((data) => {
                this.postCallback(data)
              }).catch(res=>{
                this.isLoading=false
              });
            }
          }
        });
      },
      postCallback(data) {
        this.$message.success('操作成功')
        this.formVisible = false;
        this.$emit('created')
        this.isLoading=false
      },
    }
  }
</script>
<style lang="scss" scoped>
  ::v-deep .el-select {
    width: 100%;
  }
  ::v-deep .el-cascader{
    width: 100%;
  }
  .el-form-item--small.el-form-item {
    width: 48%;
    display: inline-block;
    vertical-align: top;
  }
  .el-date-editor--datetimerange.el-input,
  .el-date-editor--datetimerange.el-input__inner {
    width: 100%;
  }
  .el-form-item--small.el-form-item.width100 {
    width: 97%;
  }
</style>
